
import banImg1 from "../../assets/images/services/tech/tech-banner.webp";
import banImg2 from "../../assets/images/services/tech/tech-introduction.webp";
import features01 from "../../assets/images/services/tech/tech-featu-01.webp"
import features02 from "../../assets/images/services/tech/tech-featu-02.webp"
import features03 from "../../assets/images/services/tech/tech-featu-03.webp"
import features04 from "../../assets/images/services/tech/tech-featu-04.webp"
import features05 from "../../assets/images/services/tech/tech-featu-05.webp"
import features06 from "../../assets/images/services/tech/tech-featu-06.webp"
import features07 from "../../assets/images/services/tech/tech-featu-07.webp"
import features08 from "../../assets/images/services/tech/tech-featu-08.webp"

const TechConsultationData = {
    "BannerData":[
        {
            "title": "Strategic <span>Tech<br/>Consultation</span> <br/>Services",
            "bannerBtnText": 'Let’s Connect',
            "bannerBigimg" : `${banImg1}`,
            "bannerAlt": 'Android App Development',
        },
    ],

    "Introduction":[
        {
            "introContent" :`Our Tech Consultation service is your strategic partner in navigating the ever-evolving landscape of technology. Whether you need guidance on adopting new technologies, optimizing existing systems, or developing a tech roadmap for your business, our experienced consultants are here to help. We combine industry expertise with a deep understanding of your business to deliver tailored solutions that drive innovation and growth.`,
            "introImg": `${banImg2}`,
            "brochurelink": "/",
        }
    ],

    "ServiceBenifits" : [
        {   
            "benifitCont" : "Gain a competitive edge with strategic technology initiatives",
        },
        {
            "benifitCont" : "Optimize IT resources and reduce operational costs",
        },
        {
            "benifitCont" : "Enhance cybersecurity posture and mitigate risks",
        },
        {
            "benifitCont" : "Leverage data insights for informed decision-making",
        },
        {
            "benifitCont" : "Streamline business processes and improve efficiency",
        },
        {
            "benifitCont" : "Ensure compliance with industry regulations",
        },
        // {
        //     "benifitCont" : "Benefit from ongoing support and updates",
        // },
    ],

    "FeaturesServices":[
        {
          
            "featureDescriptiom":"Comprehensive technology assessment and analysis",
            "FeatImg" : `${features01}`,
            "FeatImgAltTag" : "Native Android Apps",
            
        },
        {
            
            "featureDescriptiom":"Customized tech strategies aligned with your business goals",
            "FeatImg" : `${features02}`,
            "FeatImgAltTag" : "Web Apps",
        },
        {
            
            "featureDescriptiom":"Expert guidance on adopting emerging technologies (Generative AI, LLMs, Machine Learning)",
            "FeatImg" : `${features03}`,
            "FeatImgAltTag" : "Web Apps",
        },
        {
            
            "featureDescriptiom":"IT infrastructure optimization and modernization, Cloud migration",
            "FeatImg" : `${features04}`,
            "FeatImgAltTag" : "Web Apps",
        },
        {
            
            "featureDescriptiom":"Cybersecurity assessment and risk management",
            "FeatImg" : `${features05}`,
            "FeatImgAltTag" : "Web Apps",
        },
        {
            
            "featureDescriptiom":"Data analytics and business intelligence solutions",
            "FeatImg" : `${features06}`,
            "FeatImgAltTag" : "Web Apps",
        },
        {
            
            "featureDescriptiom":"Setting up Center of Excellence (Omni channel Customer Support, Process Automations, Chatbots)",
            "FeatImg" : `${features07}`,
            "FeatImgAltTag" : "Web Apps",
        },
        {
            
            "featureDescriptiom":"Compliance and regulatory guidance",
            "FeatImg" : `${features08}`,
            "FeatImgAltTag" : "Web Apps",
        },
       
    ],


    "FooterCtaSection":[
        {
            "CtaDescriptiom":"Empower your business with strategic tech insights. Contact us today to schedule a consultation and discover how our Tech Consultation service can drive your digital transformation.",
            "CtaBtnText": 'Let’s Connect',
            "CtaBtnLink": '/get-a-quote',
        },
    ],


    
} 

export default TechConsultationData